.input {
  border-top: 0;
  border-left: 0;
  border-right: 0;
  border-bottom: solid 1px var(--gray-alt);
  border-radius: 0;
  font-weight: 400;
  font-size: 14px;
  color: var(--text-dark);
  background-color: var(--gray-lightest);
  line-height: 1.5;
  height: 40px;
  padding: 8px 16px;
  outline: none;
}

.input::placeholder {
  color: var(--gray);
}

.input:focus {
  border-bottom-color: var(--primary);
}

.input:disabled {
  background-color: var(--white);
  color: var(--gray-alt);
}

.inputPhoneWrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.inputPhone {
  min-width: 130px;
}

.inputPhoneWithMargin {
  margin-right: 2rem;
}

.selectCountryCode {
  width: 80px;
  margin-right: 6px;
}
